<template lang="pug">
v-container(
  fluid
  data-e2e="crm-inbox"
  class=" tw-h-full tw-overflow-hidden tw-rounded tw-pt-0 tw-m-0 tw-p-0 md:tw-p-3 tw-pb-0"
  style="background: #f5f5fa"
)
  template(v-if="loading")
    div(class="tw-flex tw-h-full tw-bg-white tw-rounded-md tw-items-center tw-justify-center")
      v-progress-circular(indeterminate color="primary" size="48" aria-label="Loading leads")
  template(v-else-if="fetchError")
    div(role="alert" class="tw-flex tw-h-full tw-bg-white tw-rounded-md")
      kubiqa-misc-empty-state(
        :title="$t('Common.emptyStates.loadErrorTitle')"
        :description="$t('Common.emptyStates.loadErrorBody')"
        :action-label="$t('Common.emptyStates.retry')"
        icon="mdi-alert-circle-outline"
        @action="load(appliedFilter)"
      )
  template(v-else-if="leads.length === 0")
    div(class="tw-flex tw-flex-row tw-h-full tw-bg-white tw-p-0 md:tw-p-5 tw-mt-0 tw-rounded-md")
      div(class="tw-flex tw-flex-col tw-w-full")
        v-row(no-gutters justify="center" class="tw-pt-4")
          v-col(cols="auto")
            v-btn-toggle(v-model="inbox_filter" mandatory rounded dense color="red accent-3" borderless)
              v-btn(@click="filter('new')")
                v-icon(x-small color="blue lighten-1") mdi-circle
                span(class="tw-ml-2 tw-text-blueGray-darken-3") {{ $t('Common.new') }}
              v-btn(@click="filter('converted')")
                v-icon(x-small color="green lighten-2") mdi-circle
                span(class="tw-ml-2 tw-text-blueGray-darken-3") {{ $t('Leads.Common.converted') }}
              v-btn(@click="filter('discarded')")
                v-icon(x-small color="orange lighten-1") mdi-circle
                span(class="tw-ml-2 tw-text-blueGray-darken-3") {{ $t('Leads.Common.discarded') }}
        div(class="tw-flex tw-flex-grow tw-items-center tw-justify-center")
          kubiqa-misc-empty-state(
            :title="$t(appliedFilter === 'new' ? 'Common.emptyStates.inboxTitle' : 'Common.emptyStates.filteredInboxTitle')"
            :description="$t(appliedFilter === 'new' ? 'Common.emptyStates.inboxBody' : 'Common.emptyStates.filteredInboxBody')"
            :illustration="require('@/assets/images/illustrations/inbox.svg')"
          )
  template(v-else)
    div(class="tw-flex tw-flex-row tw-h-full tw-w-full tw-bg-white pa-0 md:pa-5 tw-mt-0 tw-rounded-md")
      div(class=" tw-flex-col tw-h-full tw-w-full ")
        div(class="tw-flex tw-h-full tw-w-full tw-px-2 md:tw-px-5 tw-pb-10 ")
          v-row(no-gutters class="tw-bg-gray-500 tw-h-full tw-w-full ")
            v-col(class="tw-h-full tw-w-full")
              v-row(no-gutters justify="space-around" class="tw-flex-shrink-default")
                v-col(cols="auto")
                  v-btn-toggle(
                    v-model="inbox_filter"
                    mandatory
                    rounded
                    dense
                    color="red accent-3"
                    borderless
                  )
                    v-btn(@click="filter('new')")
                      v-icon(x-small color="blue lighten-1") mdi-circle
                      span(class="tw-ml-2 tw-text-blueGray-darken-3") {{ $t('Common.new') }}
                    v-btn(@click="filter('converted')")
                      v-icon(x-small color="green lighten-2") mdi-circle
                      span(class="tw-ml-2 tw-text-blueGray-darken-3") {{ $t('Leads.Common.converted') }}
                    v-btn(@click="filter('discarded')")
                      v-icon(x-small color="orange lighten-1") mdi-circle
                      span(class="tw-ml-2 tw-text-blueGray-darken-3") {{ $t('Leads.Common.discarded') }}
              v-row(no-gutters class=" tw-overflow-scroll tw-h-full tw-pb-8")
                v-col(class="tw-h-full")
                  v-row(no-gutters class=" tw-h-full tw-overflow-scroll")
                    v-col
                      div(v-for="(lead, index) in leads" :key="index")
                        kubiqa-inbox-list-item(
                          :is-fake="false"
                          :lead-id="lead.id"
                          :is-active="lead.id == leadSelected"
                          :item="lead.status == appliedFilter ? lead : null"
                          @clicked="open"
                          :key="mKey"
                        )
      template(v-if="!$vuetify.breakpoint.mobile")
        div(
          v-if="leadSelected != null"
          class=" md:tw-flex xs:tw-hidden sm:tw-hidden  tw-pt-0 tw-flex-col tw-h-full tw-w-full tw-overflow-hidden col-7 tw-pb-0 tw-px-0"
        )
          v-fade-transition(mode="out-in")
            router-view(:key="mKey")
        div(v-else class="tw-flex-col col-7 tw-h-full tw-flex tw-ml-0 tw-content-center tw-w-full tw-overflow-hidden")
          v-row(class=" d-flex flex-row flex-grow-1 flex-shrink-0")
            v-col(class="fill-height")
              v-row(align="center" justify="center" class="fill-height")
                v-col(cols="auto")
                  div(class="tw-bg-gray-lighten-5 tw-rounded-full tw-text-center tw-p-20")
                    v-img(src="@/assets/images/illustrations/inbox.svg" width="230px" class="tw-self-center ")
      template(v-else)
        v-dialog(
          v-model="dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          class="tw-bg-white tw-overflow-hidden"
        )
          v-card(flat background="white" class="tw-bg-indigo-lighten-5 tw-overflow-hidden tw-h-screen")
            div(class="tw-bg-indigo-lighten-5")
              v-row(no-gutters align="center" class="tw-bg-indigo-lighten-5  ")
                v-col(cols="auto" class="pl-2 pt-1")
                  v-icon(@click="$router.push({ name: 'inbox' })" color="grey darken-1" class="tw-cursor-pointer") mdi-arrow-left-circle
                v-col(cols="auto")
                  div(@click="$router.push({ name: 'inbox' })" class="tw-capitalize pl-1 tw-cursor-pointer tw-relative") {{ $t('Common.back') }}
              v-row(no-gutters class="tw-overflow-hidden mt-n3")
                v-col(class="tw-overflow-hidden tw-h-screen")
                  router-view(:key="mKey")
</template>
<script>
export default {
  data() {
    return {
      mKey: 1,
      inbox_filter: 0,
      appliedFilter: 'new',
      fetchError: false,
    };
  },
  computed: {
    loading() {
      return this.$store.getters['loading'];
    },
    leadSelected() {
      return this.$route.params.id;
    },
    leads() {
      return this.$store.getters['leads/list'];
    },
    dialog: {
      get() {
        return this.leadSelected != null;
      },
      set(val) {
        if (!val) {
          //this.$router.push({ name: 'inbox' });
        }
      },
    },
  },
  created() {
    this.$store.commit('leads/SET_CURRENT_LEAD', null);
    this.$store.commit('displaySidebar', true);
    this.$store.commit('displayWebsiteToolbar', false);
    this.$store.commit('displayMainToolbar', true);
  },
  mounted() {
    this.load('new');
  },
  methods: {
    open(id) {
      this.mKey = ++this.mKey;
      this.$router.push({ name: 'inboxItem', params: { id: id } });
    },
    filter(filter) {
      //set the router path to /inbox
      this.$router.push({ name: 'inbox' });
      this.appliedFilter = filter;
      this.load(filter);
      this.mKey = ++this.mKey;
    },
    async load(filter) {
      this.fetchError = false;
      const filters = new URLSearchParams();
      filters.append('filter[status]', filter);
      const result = await this.$store.dispatch('leads/list', filters);
      this.fetchError = result === null || result === undefined;
    },
  },
};
</script>
